import Available from './available'
import PrefetchStock from './prefetch-stock'
import prefetchStock from './stores'

export default {
	Available,
	PrefetchStock,
	prefetchStock,
}